import Alpine from 'alpinejs';
import ContactWormJpg from '@images/contact_worm.jpg';
import ContactWormWeb from '@images/contact_worm.jpg?format=webp';
document.addEventListener('alpine:init', () => {
  Alpine.data('contactBlock', () => ({
    ContactWormWeb,
    ContactWormJpg,
    targetIsVisible: false,
    triggerVisible() {
      this.targetIsVisible = true;
    },
  }));
});
